import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const APPROVALS_FILTER_STORAGE = 'service_pr_approvals_filter';

const ServicePrApprovalsList = ({
  getPrListing,
  prListData,
  acceptApproval,
  rejectApproval,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const headers = [
    'PR Number',
    'Site Number',
    'PR Type',
    'Site Name',
    'Area',
    'City',
    'Vendor',
    'PR Amount',
    'Raised By',
    'Creation Date',
    // 'Approve/Reject',
    'View'
  ]
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [remark, setRemark] = useState("");
  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("mainSiteCont") &&
        localStorage.getItem("mainSiteCont")
    );
    if(installationCont){
      localStorage.setItem("mainGoLive", JSON.stringify(""));
      localStorage.setItem("mainSiteCont", 0);
    }
    
  }, []);

  useEffect(() => {
    if (getPrListing !== null)
      (async () => {
        const raw = localStorage.getItem(APPROVALS_FILTER_STORAGE);
        const savedFilter =
          raw && raw !== 'undefined' ? JSON.parse(raw) : null;
        setIsLoading(true);
        if (savedFilter) {
          setFilterData(savedFilter);
          await getPrListing(savedFilter, 1, 8);
        } else {
          await getPrListing(null, 1, 8);
        }
        setIsLoading(false);
      })();
  }, [getPrListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (nextFilter) => {
    localStorage.setItem(APPROVALS_FILTER_STORAGE, JSON.stringify(nextFilter));
    setIsLoading(true);
    setFilterData(nextFilter);
    await getPrListing(nextFilter, 1, 8);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    const tableData = [
      'id',
      'pr_no',
      'site_no',
      'pr_type',
      'site_name',
      'area_name',
      'city_name',
      'firm_name',
      'total_amount',
      'user_name',
      'created_at',
      // 'Approve/Reject',
      'view_details'
    ];
    
    if (prListData && prListData.data) {
      const data = prListData.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            'view_details': `${baseUrl}/pr-confirmation-details`,
            // Action: [
            //   {
            //     name: 'Service PR',
            //     link: `/dashboard/vendor-allocation/2`,
            //   }
            // ],
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(prListData.total / prListData.per_page));
    }
  }, [prListData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getPrListing(filterData,val.selected + 1 , 8);
    setIsLoading(false);
  };

  const updatePrApproval = async (data) => {
    setActionData(data);
    setIsModal(true);
  };

  const handleContinue = async () => {
    setIsModal(false);
    setIsLoading(true);

    let requestData = {
      prId: actionData.actionObj.id,
      remarks: remark
    };

    if (actionData.action === "accept") {
      requestData.actionFor = "Accept";
      requestData.status = 1;

      await acceptApproval(requestData).then(async (response) => {
        setIsLoading(false);
        if (response) {
          await getPrListing(filterData, 1, 8);
          setIsSuccessModel(true);
        }
      });
    } 
    else if (actionData.action === "reject") {
      requestData.actionFor = "Reject";
      requestData.status = 9;

      await rejectApproval(requestData).then(async (response) => {
        setIsLoading(false);
        if (response) {
          await getPrListing(filterData, 1, 8);
          setIsSuccessModel(true);
        }
      });
    }
  };


  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="#" onClick={func} className="btn btn-transparent">
          {localization.returnToPrList}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.prApproval}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={prListData?.from}
        onPageChange={onPageChange}
        onChange={(data) => {updatePrApproval(data)}}
        detailList={prListData && prListData.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        servicePrApprovalsFilters
      />
    
      <ModalPop
        title={
          actionData?.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <Fragment>
          <div className="modal-body">
            <div className="text-center">
              <h5>
                {actionData?.action === "accept"
                  ? localization.approvePR
                  : localization.rejectPR}
              </h5>

              <div className="form-group">
                <ConstantInput
                  label={localization.addRemark}
                  required
                  isStarRequired={true}
                  type="text"
                  handleChange={(val) => setRemark(val)}
                />
              </div>

              <Button
                className="btn btn-primary"
                onClick={handleContinue}
                disabled={!remark}
              >
                {localization.continue}{' '}
                <img src="../images/arrow-right.png" alt="" />
              </Button>
            </div>
          </div>
        </Fragment>
      </ModalPop>

    </Layout>
  );
};
export default ServicePrApprovalsList;
